import { render } from "./TopQueriesChart.vue?vue&type=template&id=240ebbc8&scoped=true"
import script from "./TopQueriesChart.vue?vue&type=script&lang=js"
export * from "./TopQueriesChart.vue?vue&type=script&lang=js"

import "./TopQueriesChart.vue?vue&type=style&index=0&id=240ebbc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240ebbc8"]])

export default __exports__